import { AccountCircle, ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Badge, Box, Divider, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { removeStoredToken } from "src/utils/auth";
import NotificationsDialog from "./NotificationsDialog";

type SidebarMyProfileSectionProps = {
  unreadNotificationCount: number
}

export const SidebarMyProfileSection: FC<SidebarMyProfileSectionProps> = ({unreadNotificationCount}): JSX.Element => {
  const [isOpenNotifications, setIsOpenNotifications] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <Box>
      <NotificationsDialog
        isOpen={isOpenNotifications}
        setIsOpen={setIsOpenNotifications}
      />

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          sx={{
            "&:hover": {
              backgroundColor: "rgba(255,231,219,255)", // TODO: add to palette later ?
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexFlow: "row",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <AccountCircle />
            <Typography>
              Meu perfil
            </Typography>
          </Box>
        </AccordionSummary>
        <Divider />
        <AccordionDetails>
          <List disablePadding>
            <ListItemButton
              onClick={() => {
                setIsOpenNotifications(true)
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(255,231,219,255)",
                  borderRadius: 2,
                },
              }}
            >
              <ListItemText primary="Notificações"/>
              <Badge
                badgeContent={unreadNotificationCount}
                color="primary"
              />
            </ListItemButton>
            <ListItemButton
              LinkComponent={"a"}
              href={"/usuario/alterar-senha"}
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(255,231,219,255)",
                  borderRadius: 2,
                },
              }}
            >
              <ListItemText primary={"Alterar senha"} />
            </ListItemButton>
            <ListItemButton
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(255,231,219,255)",
                  borderRadius: 2,
                },
              }}
              onClick={() => {
                if (window.confirm("Deseja mesmo sair da plataforma Eezycare e voltar para a tela de Login?")) {
                  removeStoredToken();
                  navigate("/login");
                }
              }}
            >
              <ListItemText primary={"Sair"} />
            </ListItemButton>
          </List>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}